import { FundByMeasurementDate, ParsedFundByMeasurementDate } from 'common/types/store';

const parseFundByMeasurementDateData = (
  fundsByMeasurementDate: FundByMeasurementDate[]
): ParsedFundByMeasurementDate[] =>
  fundsByMeasurementDate.map(fundByMeasurementDate => ({
    fund: fundByMeasurementDate.fund.id,
    measurement_date: fundByMeasurementDate.measurementDate?.id,
  }));

export default parseFundByMeasurementDateData;
